import { ReactNode, createContext, useContext, useState } from "react";

export type User = {
  name: string;
  user_id: number;
  role: string;
  mobile?: string;
  email?: string;
};

const UserContext = createContext<[User | null, (user: User | null) => void]>([
  null,
  (_) => {},
]);

export function UserContextProvider({
  defaultValue,
  children,
}: {
  children: ReactNode | ReactNode[];
  defaultValue: { name: string; user_id: number; role: string };
}) {
  const returnValue = useState<User | null>(defaultValue || null);
  return (
    <UserContext.Provider value={returnValue}>{children}</UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext)[0];
}

export function useSetUser() {
  return useContext(UserContext)[1];
}
